// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 491) return "static/chunks/491-3e78e09e870855e7.js";
	if (chunkId === 41) return "static/chunks/41-7587e89d739fecc5.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"99e63da17b81f99b","319":"222cfcfdedf88644","340":"8e357b54413bfc3b","367":"ee938935f583ff86","639":"e7b660adfa99260e","748":"3c6f7ee39b8ace0a"}[chunkId] + ".js";
};